import React, { useRef, useState, useEffect, useMemo, useCallback } from 'react';
import { apis, apiHolder as api, getIn18Text, EApprovalObjectType, } from 'api';
import { BackTop, Affix } from 'antd';
import classnames from 'classnames';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { systemIsWindow } from '../../util';
import './index.scss';
import Header from './Header';
import Content from './content/Content';
import Toobar from './Toobar';
import ReplyWrap from './ReplyWrap';
import useDebounceLocalData from '../../hooks/useDebounceLocalData';
import ContentTips from './ContentTips';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import ContentSearch from './ContentSearch';
import { ReactComponent as BackToTopNew } from '@/images/icons/back_to_top_new.svg';
import styles from './index.module.scss';
import debounce from 'lodash/debounce';
import useGetUniqueFn from '@web-mail/hooks/useGetUniqueFn';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
import { MAIL_MENU_ITEM } from '@web-mail/common/constant';
import EdmReplyFeedback from './EdmReplyFeedback';
import useGetReadStatus from '@web-mail/components/ReadMail/hooks/useGetReadStatus';
import HorizontalScrollBar from './component/VScrollBar/scrollBar';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import ApprovalRecordDetailDrawer from '@web-approval-flow/components/ApprovalRecordDetailDrawer';
const AffixHeader = props => {
    const { target } = props;
    const [isPin] = useState2RM('fixedReadMailHeader');
    return isPin ? (React.createElement(Affix, { offsetTop: 0, target: target, className: styles.fixedHedContent },
        React.createElement("div", { className: styles.fixedMailHead }, props.children))) : (React.createElement(React.Fragment, null, props.children));
};
const SingleMail = props => {
    var _a, _b, _c, _d;
    const { content, readOnly = false, mailIdChangeRecord, translateInfo, handleTranslateLang, featureConfig, sliceId, isUpDown, searchInputVisible, setSearchInputVisible, forceUpdate, unlockMail, readmailFrom, nonAttachment, } = props;
    const MailApi = api.api.requireLogicalApi(apis.mailApiImpl);
    const approvalFlowApi = api.api.requireLogicalApi(apis.approvalFlowApiImpl);
    const dispatch = useAppDispatch();
    const contentRef = useRef([]);
    const mailContentRef = useRef(null);
    const mailListResizeProcessing = useAppSelector(state => state.mailReducer.mailListResizeProcessing);
    const [emoticonInfo, setEmoticonInfo] = useState();
    const [iframeContentWidth, setIframeContentWidth] = useState(0);
    const [iframeWidth, setIframeWidth] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [searchIndex, setSearchIndex] = useState(-1);
    const [searchCount, setSearchCount] = useState(0);
    const [freezeMouse, setFreezeMouse] = useState(false);
    const [approvalFlow, setApprovalFlow] = useState(undefined);
    const [drawerState, setDrawerState] = useState({
        visible: false,
        recordId: '',
    });
    const currentSearchState = useRef({
        index: -1,
        count: 0,
        text: '',
        matchCase: false,
        wholeWord: false,
        inSelection: false,
    });
    const [showMailHead, setShowMailHead] = useState(false);
    const [isPin] = useState2RM('fixedReadMailHeader');
    const [keyword, setKeyword] = useState('');
    const localContent = useDebounceLocalData(content, {
        exception: data => { var _a, _b; return !!((_b = (_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content); },
    });
    const mid = (_a = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _a === void 0 ? void 0 : _a.id;
    const tid = (_b = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _b === void 0 ? void 0 : _b.tid;
    const mailContent = (_d = (_c = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.content;
    useEffect(() => {
        if (mid && mailContent) {
            dispatch(Thunks.doGetCurrentMailLang({ mid }));
        }
    }, [mid, mailContent]);
    const fetchApprovalFlow = async (id) => {
        const targetId = id || tid;
        if (!targetId)
            return;
        try {
            const res = await approvalFlowApi.doGetApprovalRecordFlow({ bizId: targetId, objectType: EApprovalObjectType.email });
            const { recordId } = res;
            if (recordId) {
                setApprovalFlow(res);
                setDrawerState(Object.assign(Object.assign({}, drawerState), { recordId }));
            }
        }
        catch (error) {
            console.error('获取审批流失败', error);
        }
    };
    const debounceFetchApprovalFlow = debounce((id) => {
        fetchApprovalFlow(id);
    }, 200);
    const checkApproval = useCreateCallbackForEvent(() => {
        if (drawerState.recordId) {
            setDrawerState(Object.assign(Object.assign({}, drawerState), { visible: true }));
        }
    });
    const closeDrawer = (visible) => {
        setDrawerState(Object.assign(Object.assign({}, drawerState), { visible }));
    };
    const handleEmoticon = useCallback((data) => {
        setEmoticonInfo(data);
    }, []);
    const handleIframeSizeChange = useCallback((params) => {
        const { contentScrollWidth, iframeClientWidth } = params;
        setIframeContentWidth(contentScrollWidth);
        setIframeWidth(iframeClientWidth);
    }, []);
    const handleVScrollOnScroll = useCallback((position) => {
        var _a, _b;
        if (contentRef.current && contentRef.current[0]) {
            try {
                const irameRef = contentRef.current[0].getIframeRef();
                if (irameRef && ((_b = (_a = irameRef.current) === null || _a === void 0 ? void 0 : _a.contentDocument) === null || _b === void 0 ? void 0 : _b.documentElement)) {
                    irameRef.current.contentDocument.documentElement.scrollLeft = position;
                }
            }
            catch (e) {
                console.error('scrollLeft error', e);
            }
        }
    }, []);
    const handleIframeScroll = useCallback((position) => {
        setScrollLeft(position);
    }, []);
    const handleGetThumbUpInfo = useGetUniqueFn(data => {
        setEmoticonInfo(data);
    }, [localContent === null || localContent === void 0 ? void 0 : localContent.id]);
    const getThumbUpInfo = useCallback(debounce((mid, tid = '', _account = '') => {
        MailApi.getThumbUpInfo(mid, tid, undefined, _account)
            .then(data => {
            handleGetThumbUpInfo(data);
        })
            .catch(err => {
            setEmoticonInfo({});
            console.error('setEmoticonInfo error', err);
        });
    }, 1000), [handleGetThumbUpInfo]);
    const getThumbUpInfoRef = useCreateCallbackForEvent(getThumbUpInfo);
    useEffect(() => {
        setIframeContentWidth(0);
        currentSearchState.current.index = -1;
        currentSearchState.current.count = 0;
        currentSearchState.current.text = '';
        setSearchIndex(-1);
        setSearchCount(0);
        setSearchInputVisible(false);
        setShowMailHead(false);
        setScrollLeft(0);
    }, [localContent === null || localContent === void 0 ? void 0 : localContent.id]);
    useMsgRenderCallback('mailMenuOper', ev => {
        if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'searchInContent') {
            setSearchInputVisible(true);
        }
    });
    useEffect(() => {
        setEmoticonInfo({});
        getThumbUpInfoRef(localContent.id, localContent.entry.tid, localContent === null || localContent === void 0 ? void 0 : localContent._account);
    }, [localContent === null || localContent === void 0 ? void 0 : localContent.id]);
    const { openRecordData, setOpenRecordData, readStatus, setReadStatus, rclStatus, readOnlyStatus, debounceGetStatusOrDetail, getStatusOrDetail, getMailReadDetail } = useGetReadStatus(content);
    useEffect(() => {
        setOpenRecordData({ count: 0, records: [] });
        debounceGetStatusOrDetail(localContent);
    }, [localContent === null || localContent === void 0 ? void 0 : localContent.id]);
    const refreshData = useCreateCallbackForEvent(() => {
        const id = localContent === null || localContent === void 0 ? void 0 : localContent.id;
        if (!id)
            return;
        getStatusOrDetail(localContent);
    });
    const hideToolbarElement = useMemo(() => {
        return (readOnly || isUpDown) && !(content === null || content === void 0 ? void 0 : content.isTpMail) && (content === null || content === void 0 ? void 0 : content.mailFrom) !== 'biz';
    }, [readOnly, isUpDown, content === null || content === void 0 ? void 0 : content.isTpMail, content === null || content === void 0 ? void 0 : content.mailFrom]);
    const ToobarElement = useMemo(() => {
        return (React.createElement(Toobar, { content: localContent, listData: readStatus, showMailDiscuss: !!((featureConfig === null || featureConfig === void 0 ? void 0 : featureConfig.mailDiscuss) && !(localContent === null || localContent === void 0 ? void 0 : localContent.localFilePath)), showMailHead: showMailHead, onShowMailHeadChange: setShowMailHead }));
    }, [localContent, readStatus, featureConfig, showMailHead]);
    const HeaderElement = useMemo(() => {
        return (React.createElement(Header, { sliceId: sliceId, content: content, nonAttachment: nonAttachment, listData: readStatus, readOnly: readOnly || !!(content === null || content === void 0 ? void 0 : content.localFilePath), showMailDiscuss: featureConfig === null || featureConfig === void 0 ? void 0 : featureConfig.mailDiscuss, mailTagCloseAble: featureConfig === null || featureConfig === void 0 ? void 0 : featureConfig.mailTagIsCloseAble, featureConfig: featureConfig, forceUpdate: !!forceUpdate, menu: [
                {
                    key: MAIL_MENU_ITEM.EMAIL_HEADER,
                    name: mail => {
                        return showMailHead ? getIn18Text('CHAKANYOUJIAN') : getIn18Text('CHAKANXINTOU');
                    },
                    onClick: mails => {
                        setShowMailHead(!showMailHead);
                    },
                },
            ] }));
    }, [content, readStatus, readOnly, featureConfig, showMailHead, nonAttachment]);
    const ContentElement = useMemo(() => {
        return (React.createElement(Content, { ref: re => {
                if (re) {
                    contentRef.current[0] = re;
                }
            }, content: localContent, isrcl: readStatus === null || readStatus === void 0 ? void 0 : readStatus.isrcl, mailIdChangeRecord: mailIdChangeRecord, readOnly: readOnly || !!(localContent === null || localContent === void 0 ? void 0 : localContent.localFilePath), onIframeScroll: handleIframeScroll, onIframeSizeChange: handleIframeSizeChange, featureConfig: featureConfig, forceUpdate: forceUpdate, freezeMouse: freezeMouse || mailListResizeProcessing }));
    }, [localContent, readStatus === null || readStatus === void 0 ? void 0 : readStatus.isrcl, readOnly, featureConfig, forceUpdate, freezeMouse, mailListResizeProcessing]);
    const upDownReply = useRef(null);
    const handleReplayExpand = useCreateCallbackForEvent(() => {
        if (isUpDown) {
            setTimeout(() => {
                var _a;
                if (upDownReply.current) {
                    (_a = upDownReply.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
            }, 50);
        }
    });
    const ReplyElement = useMemo(() => {
        return React.createElement(ReplyWrap, { content: localContent, mid: localContent === null || localContent === void 0 ? void 0 : localContent.id, emoticonInfo: emoticonInfo, handleEmoticon: handleEmoticon, onExpand: handleReplayExpand });
    }, [localContent === null || localContent === void 0 ? void 0 : localContent.id, emoticonInfo, handleEmoticon]);
    const ContentTipsElement = useMemo(() => {
        if (readOnly) {
            if (localContent.mailFrom === 'subordinate' || readmailFrom === 'marketResultStat') {
                return (React.createElement(ContentTips, { listData: readStatus, rclData: rclStatus, readOnlyData: readOnlyStatus, openRecordData: openRecordData, getMailReadDetail: getMailReadDetail, refreshData: refreshData, emoticonInfo: emoticonInfo, handleEmoticon: handleEmoticon, content: localContent, translateInfo: translateInfo, handleTranslateLang: handleTranslateLang, featureConfig: featureConfig, forceUpdate: forceUpdate, unlockMail: unlockMail, approvalFlow: approvalFlow, fetchApprovalFlow: fetchApprovalFlow, checkApproval: checkApproval, style: { margin: '16px 0 ' }, showMailHead: showMailHead, onShowMailHeadChange: setShowMailHead, includeTips: { translate: true } }));
            }
            if (process.env.BUILD_ISEDM) {
                return React.createElement(EdmReplyFeedback, { content: content, readOnly: true });
            }
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(ContentTips, { listData: readStatus, rclData: rclStatus, readOnlyData: readOnlyStatus, openRecordData: openRecordData, getMailReadDetail: getMailReadDetail, refreshData: refreshData, emoticonInfo: emoticonInfo, handleEmoticon: handleEmoticon, content: localContent, translateInfo: translateInfo, handleTranslateLang: handleTranslateLang, featureConfig: featureConfig, forceUpdate: forceUpdate, approvalFlow: approvalFlow, fetchApprovalFlow: fetchApprovalFlow, checkApproval: checkApproval, unlockMail: unlockMail, style: { margin: '16px 0 ' }, showMailHead: showMailHead, onShowMailHeadChange: setShowMailHead }));
    }, [
        localContent,
        readStatus,
        openRecordData,
        refreshData,
        emoticonInfo,
        handleEmoticon,
        translateInfo,
        handleTranslateLang,
        featureConfig,
        forceUpdate,
        showMailHead,
        readOnly,
        approvalFlow,
    ]);
    const [mailReadContentClassNames] = useState(() => {
        return systemIsWindow() ? 'mail-read-content-scrollwrap-inwin' : 'mail-read-content-scrollwrap';
    });
    const searchContent = useCallback((keyword, forward = true) => {
        var _a, _b;
        if (contentRef.current && contentRef.current[0]) {
            const searchFind = (_b = (_a = contentRef.current[0].getIframeRef().current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.searchFind;
            typeof searchFind === 'function' && searchFind(currentSearchState.current, keyword, forward);
            setSearchIndex(currentSearchState.current.index);
            setSearchCount(currentSearchState.current.count);
        }
    }, []);
    useEffect(() => {
        if (process.env.BUILD_ISLINGXI) {
            return;
        }
        if (tid) {
            setApprovalFlow(undefined);
            setDrawerState({ visible: false, recordId: '' });
            debounceFetchApprovalFlow(tid);
        }
    }, [tid]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mail-read-content-wrap single-mail-warp" },
            hideToolbarElement ? React.createElement(React.Fragment, null) : ToobarElement,
            React.createElement("div", { className: "mail-read-content" },
                React.createElement("div", { style: { overflow: 'auto' }, className: mailReadContentClassNames, ref: mailContentRef },
                    React.createElement(AffixHeader, { target: () => mailContentRef.current },
                        readOnly ? React.createElement("div", { style: { height: 20 } }) : React.createElement(React.Fragment, null),
                        isUpDown ? React.createElement("div", { style: { height: 8 } }) : React.createElement(React.Fragment, null),
                        React.createElement(ContentSearch, { index: searchIndex, count: searchCount, keyword: keyword, setKeyword: setKeyword, searchInputVisible: searchInputVisible, setSearchInputVisible: setSearchInputVisible, searchContent: searchContent }),
                        HeaderElement),
                    (localContent === null || localContent === void 0 ? void 0 : localContent.localFilePath) ? React.createElement(React.Fragment, null) : ContentTipsElement,
                    ContentElement,
                    React.createElement(BackTop, { visibilityHeight: 200, target: () => mailContentRef.current || window, className: "read-mail-back-top-icon", "data-test-id": "read-backtop" },
                        React.createElement(BackToTopNew, null)),
                    React.createElement("div", { style: { position: 'absolute', width: '100%', bottom: '0', zIndex: 100 } },
                        React.createElement(HorizontalScrollBar, { viewWidth: iframeWidth, scrollWidth: iframeContentWidth, scrollLeft: scrollLeft, onScroll: handleVScrollOnScroll, show: true, onDragStart: () => {
                                setFreezeMouse(true);
                            }, onDragEnd: () => {
                                setFreezeMouse(false);
                            } })),
                    isUpDown && localContent.mailFrom !== 'subordinate' && React.createElement("div", { className: classnames(styles.updownReplay) }, ReplyElement))),
            readOnly || isUpDown || (localContent === null || localContent === void 0 ? void 0 : localContent.localFilePath) ? React.createElement(React.Fragment, null) : ReplyElement,
            process.env.BUILD_ISEDM ? React.createElement(ApprovalRecordDetailDrawer, { drawerState: drawerState, onClose: closeDrawer }) : null)));
};
export default SingleMail;
